module.exports = __webpack_public_path__ + "static/media/staff-scarfy.02f04653.png";